import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_SyntaxTreeVariants_TAC = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Variants of Syntax trees - Three Address Code"
    videos={[
      "https://www.youtube.com/embed/TXlZDD4DpdY",
      "https://www.youtube.com/embed/yFVCw0N0nxo",
    ]}
    takeaways={[]}
    questions={[
      "Generate the Quadruple, Triple and Indirect Triple representation of the three address code of the following statement: a+b*c/e↑f+b*a",
      "Construct the syntax tree for the expression ‘X*(Y-5)+(Z/W)’ using appropriate nodes and edges",
      `Consider the following Clike code that Involves pointers and dynamic memory allocation. Generate the three-address code(TAC) for the above code. Assume that the TAC has an instruction alloc(n) that performs the malloc(). 

int* allocateAndFillArray(int size) { 

int* arr = (int*) malloc(size * sizeof(int)); 

for (int i = 0; i < size; i++) { 

arr[i] = i * 2; 

} 

return arr; 

} 

int main() { 

int n = 5; 

int* p = allocateAndFillArray(n); 

int sum = 0; 

for (int i = 0; i < n; i++) { 

sum += p[i]; 

} 

return sum; 

}`,
      `Consider the given code. Translate the program as Quadruple, Triple, and Indirect Triple. 

for (i=2; i <= n; i++) 

a[i] = TRUE; 

count= 0; 

s = sqrt(n); 

for (i=2; i <= s; i++) 

if (a[i]) /* i has been found to be a prime */{ 

count++; 

for (j=2*i; j <= n; j = j+i) 

a[j] = FALSE; /* no multiple of i is a prime */ 

}`,
      `Generate 3AC for the following code snippet and represent the following code into Quadruple, triples, and indirect triples form. 

main() 

{ 

int i; 

int a[10]; 

i=1; 

while (i <= 701) 

{ 

a[i]= 0; 

i=i+1; 

} 

}`,
      `Generate the intermediate code for the given code snippet. 
int a[10][10]; 
for(i=0;i<10;i++) 
for(j=0;j<10;j++) 
{ a[i][j]=i*j; 
If((i*j)>50) 
break; 
}`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_SyntaxTreeVariants_TAC;
